import { render, staticRenderFns } from "./settings-organization.vue?vue&type=template&id=5fd2b7b4&scoped=true&"
import script from "./settings-organization.vue?vue&type=script&lang=js&"
export * from "./settings-organization.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization.vue?vue&type=style&index=0&id=5fd2b7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2b7b4",
  null
  
)

export default component.exports